<ng-container>
  @if (visible()) {
    <kendo-dialog (close)="dialogService.close()">
      <kendo-dialog-titlebar> {{ title() }} </kendo-dialog-titlebar>
      <div class="flex size-full min-h-[124px] flex-col items-center justify-center gap-y-4 md:w-[372px]">
        <p class="text-center">{{ content() }}</p>
      </div>
      <kendo-dialog-actions class="flex-col md:flex-row-reverse">
        <button [disabled]="isLoading()" kendoButton [class]="classList()" (click)="dialogService.onContinue()">
          {{ isLoading() ? "Deactivating..." : continueText() }}
        </button>
        <button kendoButton class="w-full" (click)="dialogService.onCancel()">{{ cancelText() }}</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  }
</ng-container>
